import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
  width: 90vw;
`;

export const ContainerModal = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;

  background-color: #f9fafb;

  max-width: 1200px; // Largura máxima em telas grandes
  width: 90%; // Largura relativa em telas menores
  margin: 0 auto; // Centraliza o modal na tela
  margin-bottom: 32px;
  height: 90%; // Altura relativa em telas menores
  @media (max-width: 768px) {
    width: 95%; // Ajusta a largura para telas menores
    padding: 15px; // Reduz o padding em telas menores
  }
`;

export const ButtonContainer = styled.div`
  gap: 10px;
  display: flex;
  margin-left: 10px;

  @media (max-width: 768px) {
    flex-direction: column; // Coloca os botões em coluna em telas menores
    gap: 5px;
  }
`;

export const RowContainer = styled.div`
  margin-bottom: 10px;
  display: flex;
  width: 100%;
  flex-wrap: wrap; // Permite que os elementos quebrem para a próxima linha em telas menores

  @media (max-width: 768px) {
    flex-direction: column; // Coloca os elementos em coluna em telas menores
  }
`;

export const TextareaContainer = styled.div`
  flex: 1;
`;

export const Textarea = styled.textarea`
  resize: vertical;
  min-height: 50px;
  height: auto;
  width: 100%; // Ocupa 100% da largura do container
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-family: inherit;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
`;

export const InputContainer = styled.div`
  width: 100%;
  margin-right: 10px; // Espaçamento entre os inputs

  &:last-child {
    margin-right: 0; // Remove o espaçamento do último campo
  }

  @media (max-width: 768px) {
    margin-right: 0; // Remove o espaçamento em telas menores
    margin-bottom: 10px; // Adiciona espaçamento inferior
  }
`;

export const DisplayField = styled.div`
  background-color: #f8f9fa;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  color: rgb(133, 129, 129);
  width: 100%; // Ocupa 100% da largura do container
  padding: 0.85rem 1rem;
`;

export const SelectContainer = styled.div<{ width?: number }>`
  width: ${({ width }) => width || 100}%;
  margin-right: 10px; // Espaçamento entre os selects
  &:last-child {
    margin-right: 0; // Remove o espaçamento do último campo
  }
  @media (max-width: 768px) {
    margin-right: 0; // Remove o espaçamento em telas menores
    margin-bottom: 10px; // Adiciona espaçamento inferior
  }
`;

export const StyledSelect = styled.select`
  width: 100%; // Ocupa 100% da largura do container
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  color: black;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

export const StyledInput = styled.input`
  width: 100%; // Ocupa 100% da largura do container
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  background-color: #ffffff;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

export const CloseButtonContainer = styled.div`
  margin-bottom: 8%;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 3rem;
  cursor: pointer;
  color: black;
  position: absolute;
  right: 20px; // Ajusta a posição em telas menores
  top: 10px; // Ajusta a posição em telas menores
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    color: #999;

    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    font-size: 2rem; // Reduz o tamanho do botão em telas menores
    right: 10px; // Ajusta a posição em telas menores
    top: 5px; // Ajusta a posição em telas menores
  }
`;
export const FormContainer = styled.form`
  padding-bottom: 40px; // Adiciona um padding na parte inferior do formulário

  @media (max-width: 768px) {
    padding-bottom: 30px; // Reduz o padding inferior em telas menores
  }
`;
